import FilterIcon from 'assets/icons/mono/FilterIcon';
import ApplicationCard from 'Components/campaigns/applications/ApplicationCard';
import ApplicationFilters, { defaultApplicationFilters } from 'Components/campaigns/applications/ApplicationFilters';
import { PRIVILEGE } from 'constants/privilege';
import withAccessControl from 'hoc/withAccessControl';
import useDocumentTitle from 'hooks/useDocumentTitle';
import CampaignLayout from 'Layouts/CampaignLayout'
import { useEffect, useRef, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import Skeleton from 'react-loading-skeleton';
import "react-loading-skeleton/dist/skeleton.css";
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useSearchParams } from 'react-router-dom'
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from 'reactstrap';
import { updateApplicationFilters } from 'slices/campaigns/applications/reducer';
import { fetchCampaignApplications } from 'slices/campaigns/applications/thunk';
import { AppDispatch, RootState } from 'store';
import { ApplicationFiltersNew, SortOptionLabel, SortOptions } from 'types/campaign/applications';
import { decodeBase64, encodeBase64, generateUniqueKey } from 'utils/helpers';

const CampaignApplications = () => {

    useDocumentTitle("Applications - Campaign");
    const [searchParams, setSearchParams] = useSearchParams();
    const debounceTimeout = useRef<NodeJS.Timeout | null>(null);

    const queryFilters = searchParams.get('filters');
    const dispatch: AppDispatch = useDispatch();
    useEffect(() => {
        const decodedFilters = queryFilters ? decodeBase64(queryFilters) : defaultApplicationFilters;
        dispatch(updateApplicationFilters({ ...decodedFilters, page: 1 }))
    }, [queryFilters])

    const filtersDropdown = useRef<any>(null);

    const closeFiltersDropdown = () => {
        if (filtersDropdown.current) {
            filtersDropdown.current.toggle();
        }
    };


    const { campaignId } = useParams();

    const [searchQuery, setSearchQuery] = useState('');

    // const [filters, setFilters] = useState<ApplicationsFilters>(defaultAppliedFilters);
    const filters = useSelector((state: RootState) => state.campaignApplications.filters);
    const [filterId, setFilterId] = useState(generateUniqueKey(filters, ['page']));

    const applicationsData = useSelector((state: RootState) => state.campaignApplications.campaigns[campaignId!]?.filtered_lists?.[filterId]);
    const loading = useSelector((state: RootState) => state.campaignApplications.loading);
    const applications = applicationsData?.list ?? [];
    const page = applicationsData?.page ?? 1;
    const has_more = applicationsData?.has_more ?? true;

    const error = useSelector((state: RootState) => state.campaignApplications.error);

    const [initialLoading, setInitialLoading] = useState(true);

    const setFilters = (updatedFilters: ApplicationFiltersNew) => {
        const encodedFilters = encodeBase64(updatedFilters);
        setSearchParams({ filters: encodedFilters });
        // dispatch(updateApplicationFilters(updatedFilters));
    }

    useEffect(() => {
        if (filters.q) {
            setSearchQuery(filters.q);
        }
    }, [filters.q])

    const [filtersModalVisibility, showFiltersModal] = useState(false);

    useEffect(() => {
        if (campaignId) {
            if (filters.page && filters.page === 1) {
                setInitialLoading(true);
            }
            if (debounceTimeout.current) {
                clearTimeout(debounceTimeout.current);
            }
            debounceTimeout.current = setTimeout(() => {
                dispatch(fetchCampaignApplications({ filters: filters, campaignId }))
                    .finally(() => {
                        setFilterId(generateUniqueKey(filters, ['page']));
                        setInitialLoading(false);
                    })
            }, 500)
        }
    }, [filters, campaignId])

    const nextPage = () => {
        if (has_more && campaignId && !loading) {
            const nextPageNumber = page + 1;
            dispatch(fetchCampaignApplications({ filters: { ...filters, page: nextPageNumber }, campaignId }))
        }
    }


    // useEffect(() => {
    //     if (debounceTimeout.current) {
    //         clearTimeout(debounceTimeout.current);
    //     }

    //     debounceTimeout.current = setTimeout(() => {
    //         if (searchQuery.trim().length > 2 || searchQuery.trim().length === 0) {
    //             dispatch(setApplicationSearchQeury(searchQuery))
    //         }
    //     }, 500);

    //     return () => {
    //         if (debounceTimeout.current) {
    //             clearTimeout(debounceTimeout.current);
    //         }
    //     };
    // }, [searchQuery, dispatch]);

    const searchTask = (q: string) => {
        if (debounceTimeout.current) {
            clearTimeout(debounceTimeout.current);
        }

        debounceTimeout.current = setTimeout(() => {
            if (q.trim().length > 3) {
                setFilters({ ...filters, q: q.trim(), page: 1 });
            } else if (q.trim().length === 0) {
                setFilters({ ...filters, q: '', page: 1 });
            }
        }, 500);
        setSearchQuery(q);
    }



    const getFiltersComponent = () => {

        return (
            <div className="d-flex justify-content-end align-items-center">
                <div className="campaign-layout-search-container position-relative me-2">
                    <span>
                        <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M7.66732 14.0002C11.1651 14.0002 14.0007 11.1646 14.0007 7.66683C14.0007 4.16903 11.1651 1.3335 7.66732 1.3335C4.16951 1.3335 1.33398 4.16903 1.33398 7.66683C1.33398 11.1646 4.16951 14.0002 7.66732 14.0002Z" fill="#BBD8ED" stroke="#0069AD" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M15 16L12 13" stroke="#0069AD" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </span>
                    <input type="text" placeholder='Search...' value={searchQuery} onChange={(e) => searchTask(e.target.value)} className="campaign-layout-search-input" />
                    {
                        searchQuery && (
                            <span className="search-clear-icon" onClick={() => {
                                searchTask('');
                            }}>
                                <i className='bx bx-x' />
                            </span>
                        )
                    }
                </div>
                <UncontrolledDropdown className='sort-dropdown me-2'>
                    <DropdownToggle tag={"button"} className='btn btn-white d-flex justify-content-between align-items-center w-100'>
                        <span>
                            <span className='text-muted me-1'>Sort by: </span>
                            {SortOptionLabel[filters.sort]}
                        </span>
                        <i className='mdi mdi-chevron-down fs-5' />
                    </DropdownToggle>
                    <DropdownMenu className='mt-1 p-0 w-100'>
                        {
                            Object.values(SortOptions).map((sortOption, i) => <DropdownItem key={i} onClick={() => setFilters({ ...filters, sort: sortOption })}>{SortOptionLabel[sortOption]}</DropdownItem>)
                        }
                    </DropdownMenu>
                </UncontrolledDropdown>
                <button className='btn btn-white' onClick={() => showFiltersModal(true)}><FilterIcon className="me-1" /> Filters</button>
                {/* <UncontrolledDropdown ref={filtersDropdown} >
                    <DropdownToggle tag={"button"} className='btn btn-white'>
                        <FilterIcon className="me-1" /> Filters
                    </DropdownToggle>
                    <DropdownMenu className='mt-2 p-0'>
                        <Filters defaultFilters={filters} onApply={(updatedFilters) => {
                            setFilters(updatedFilters)
                            closeFiltersDropdown()
                        }} />
                    </DropdownMenu>
                </UncontrolledDropdown> */}
            </div>
        )
    }

    return (
        <CampaignLayout
            filters={getFiltersComponent()}
        >
            <InfiniteScroll
                dataLength={applications.length + 1}
                next={nextPage}
                className='row g-3'
                hasMore={has_more}
                loader={<></>}
            >
                {
                    !initialLoading && applications.map((application, i) => <div key={i} className='col-xl-3 col-lg-4 col-md-6 col-sm-6 pe-1'><ApplicationCard campaignId={campaignId!} application={application} key={i} /></div>)
                }
                {
                    (loading || initialLoading) && Array.from({ length: 4 }).map((_, i) => (
                        <div key={i} className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                            <Skeleton height={336} className='w-100 d-block' />
                        </div>
                    ))
                }
                {
                    !(loading || initialLoading) && error &&
                    <div className="d-flex justify-content-center align-items-center">
                        <button className="theme-btn theme-btn-sm btn-primary-outlined" onClick={nextPage}>Load More <i className='ms-2 fs-5 bx bx-refresh'></i></button>
                    </div>
                }
                {
                    !(loading || initialLoading) && applications.length === 0 &&
                    <div className="d-flex w-100 justify-content-center align-items-center">
                        <div className="length-zero">
                            <h3>Currently there is no application in your list, try adjusting filters!</h3>
                        </div>
                    </div>
                }
            </InfiniteScroll>
            <ApplicationFilters
                isOpen={filtersModalVisibility}
                onClose={() => showFiltersModal(false)}
                defaultFilters={filters}
                onApply={(_filters) => {
                    setFilters({ ..._filters, page: 1, sort: filters.sort })
                }}
            />
        </CampaignLayout>
    )
}

export default withAccessControl(CampaignApplications, PRIVILEGE.CAMPAIGN.APPLICATION.INDEX)